export default {
    en: {
        tagInformationTitle: 'Information'
    },
    fr: {
        tagInformationTitle: 'Information'
    }
};
